require('../../modules/es6.string.ends-with');
module.exports = require('../../modules/_core').String.endsWith;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/ends-with.js
// module id = 232
// module chunks = 0